module.exports = __webpack_public_path__ + "static/things_take_time-texture-ae5a055bbc15bcb913cf6b1924e45f68.jpg";